import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { internalHref } from "./navigation.ts";

export default function renderBreadcrumbItem(item: { title?: ReactNode; href?: string }) {
  if (!item.href) return <span>{item.title}</span>;
  const path = internalHref(item.href);
  return path !== null ? (
    <Link to={path}>
      {item.title}
    </Link>
  ) : (
    <a href={item.href}>
      {item.title}
    </a>
  );
}
